import React, { useEffect, useState } from "react";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";
import { getLocalSelectedPostSortOption } from "@infrastructure/Persistence/LocalUserStorage";
import { Box } from "@mui/material";
import { SORT_CRITERIA_LIST } from "@shared/consts";
import { EntrypointFeed } from "../../../../Components/Modals/ContentSearchModal/EntrypointFeed";
import { SortItemType } from "../../../../Components/SortingChips/SortingChips.types";
import {
    ChipSkeleton,
    SortingChipsContainer,
} from "../../../../Components/SortingChips/SortingChips.styles";
import { PostsSortingChips } from "../PostsSorting/PostSortingChips";

export function FeedActionButtons({
    isLoading,
    onUpdate,
}: {
    isLoading: boolean;
    onUpdate: (value: SortItemType) => void;
}) {
    const [selectedSortCriteria, setSelectedSortCriteria] =
        useState<SortItemType>(
            SORT_CRITERIA_LIST[
                Math.min(
                    getLocalSelectedPostSortOption(),
                    SORT_CRITERIA_LIST.length - 1,
                )
            ],
        );
    useEffect(() => {
        onUpdate(selectedSortCriteria);
    }, [selectedSortCriteria]);

    const { getConfigs } = useGlobalConfigs();
    const showSortOptions = getConfigs()?.tippspielFeedSortingEnabled;
    return (
        <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
        >
            {showSortOptions && (
                <SortingChipsContainer
                    sx={{
                        margin: "16px 0",
                    }}
                >
                    {!isLoading ? (
                        <PostsSortingChips
                            selectedSortCriteria={selectedSortCriteria}
                            setSelectedSortCriteria={setSelectedSortCriteria}
                        />
                    ) : (
                        Array.from({ length: 2 }).map((_, key) => (
                            <ChipSkeleton
                                key={key}
                                variant="text"
                                height="32px"
                                animation="wave"
                            />
                        ))
                    )}
                </SortingChipsContainer>
            )}
            <EntrypointFeed />
        </Box>
    );
}
